// "Today · Month ⌄ · ‹ › · October 2026" controls used by the Calendar view and Planner.

import { ChevronDown, ChevronLeft, ChevronRight } from '@/components/ui/icons';
import { Popover } from '@/components/ui/Popover';
import { Menu, MenuItem } from '@/components/ui/Menu';
import { Tooltip } from '@/components/ui/Tooltip';
import type { CalendarMode } from './calendarUtils';

const MODE_LABEL: Record<CalendarMode, string> = { month: 'Month', week: 'Week', day: 'Day' };

export function CalendarNav({
  mode,
  modes,
  onMode,
  title,
  onToday,
  onPrev,
  onNext,
}: {
  mode: CalendarMode;
  modes: CalendarMode[];
  onMode: (m: CalendarMode) => void;
  title: string;
  onToday: () => void;
  onPrev: () => void;
  onNext: () => void;
}) {
  const unit = mode === 'month' ? 'month' : mode === 'week' ? 'week' : 'day';
  return (
    <div className="cal-nav">
      <button className="cal-nav-btn" onClick={onToday}>
        Today
      </button>
      <Popover
        content={(close) => (
          <Menu style={{ width: 160, minWidth: 160 }}>
            {modes.map((m) => (
              <MenuItem key={m} label={MODE_LABEL[m]} checked={m === mode} onClick={() => (onMode(m), close())} />
            ))}
          </Menu>
        )}
      >
        <button className="cal-nav-btn">
          {MODE_LABEL[mode]}
          <ChevronDown size={13} />
        </button>
      </Popover>
      <Tooltip label={`Previous ${unit}`}>
        <button className="icon-btn sm cal-nav-arrow" onClick={onPrev}>
          <ChevronLeft size={15} />
        </button>
      </Tooltip>
      <Tooltip label={`Next ${unit}`}>
        <button className="icon-btn sm cal-nav-arrow" onClick={onNext}>
          <ChevronRight size={15} />
        </button>
      </Tooltip>
      <span className="cal-nav-title">{title}</span>
    </div>
  );
}
